// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"dbd2d27f","777":"6a84342d","921":"9e5ebca9"}[chunkId] + ".chunk.js";
};